<div class="container">
    <nz-card class="items-card" class="custom-card centered-title-card">
        <div class="items-list">
            <form nz-form [formGroup]="quizform" novalidate>
                <!-- Quiz Name -->

                <input [hidden]="true" nz-input formControlName="id" />

                <nz-row [nzGutter]="16">
                    <nz-col nzSpan="18">
                        <nz-form-item>
                            <nz-form-label nzSpan="6" nzRequired>Quiz Name</nz-form-label>
                            <nz-form-control nzSpan="18" [nzErrorTip]="'Please enter quiz name'"
                                [nzValidateStatus]="quizform.get('name')?.touched && quizform.get('name')?.invalid ? 'error' : 'success'">
                                <input nz-input formControlName="name" placeholder="Enter quiz name" />
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                </nz-row>
                <nz-row [nzGutter]="16">
                    <nz-col nzSpan="18">
                        <nz-form-item>
                            <nz-form-label nzSpan="6" nzRequired>Date</nz-form-label>
                            <nz-form-control nzSpan="18" [nzErrorTip]="'Please enter Date'">
                                <nz-range-picker formControlName="dateRange" nzFormat="dd/MM/yyyy"></nz-range-picker>
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                </nz-row>
            </form>
        </div>
    </nz-card>
</div>